import { useEffect, useState } from "react";
import axios from "axios";
import { Briefcase, MapPin, Clock, ArrowSquareOut } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CareersList() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let m = true;
    axios.get(`${API}/careers`)
      .then((r) => m && setJobs(r.data?.jobs || []))
      .catch(() => m && setJobs([]))
      .finally(() => m && setLoading(false));
    return () => { m = false; };
  }, []);

  if (loading) return <p className="text-stone-500 text-sm">Loading roles…</p>;

  if (jobs.length === 0) {
    return (
      <div className="bg-stone-900/40 rounded-2xl border border-stone-800/60 p-8 text-center" data-testid="careers-empty">
        <Briefcase size={32} className="text-stone-600 mx-auto mb-2" />
        <p className="text-sm text-stone-400">No open roles right now. Check back or drop us a note via <a className="text-emerald-400" href="/contact-us">Contact Us</a>.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="careers-list">
      {jobs.map((j) => (
        <div key={j.id} className="bg-stone-900 rounded-xl border border-stone-800 p-5"
             data-testid={`career-${j.id}`}>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-emerald-600/20 flex items-center justify-center shrink-0">
              <Briefcase size={18} weight="duotone" className="text-emerald-400" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-heading text-base font-semibold text-white">{j.title}</p>
              <div className="flex flex-wrap gap-3 mt-1 text-[11px] text-stone-500">
                {j.team && <span>{j.team}</span>}
                {j.location && <span className="inline-flex items-center gap-1"><MapPin size={11} /> {j.location}</span>}
                {j.employment_type && <span className="inline-flex items-center gap-1"><Clock size={11} /> {j.employment_type}</span>}
              </div>
              {j.description && <p className="text-sm text-stone-300 mt-3 leading-relaxed whitespace-pre-line">{j.description}</p>}
              {j.requirements && (
                <div className="mt-3">
                  <p className="text-[10px] text-stone-500 uppercase tracking-wider mb-1">Requirements</p>
                  <p className="text-sm text-stone-400 leading-relaxed whitespace-pre-line">{j.requirements}</p>
                </div>
              )}
              {j.apply_url && (
                <a href={j.apply_url} target="_blank" rel="noreferrer"
                  className="mt-4 inline-flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-4 py-2 rounded-lg"
                  data-testid={`apply-${j.id}`}>
                  Apply <ArrowSquareOut size={12} />
                </a>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
